// extracted by mini-css-extract-plugin
var _1 = "SideColumnLayout-module__aboveAllContainer--nTHvm";
var _2 = "SideColumnLayout-module__aboveColumnContainer--iGWdG";
var _3 = "SideColumnLayout-module__active--yAQzk";
var _4 = "SideColumnLayout-module__activeViewContainer--y1YSI";
var _5 = "SideColumnLayout-module__animateUploadProgressBarWidth--yqsd5";
var _6 = "SideColumnLayout-module__animatedBackground--jj96y";
var _7 = "SideColumnLayout-module__compactLayoutContainer--hfUew";
var _8 = "SideColumnLayout-module__controls--Us0uP";
var _9 = "SideColumnLayout-module__controlsToggle--NzLVM";
var _a = "SideColumnLayout-module__iconContainer--rJjLq";
var _b = "SideColumnLayout-module__layoutContainer--brMDU";
var _c = "SideColumnLayout-module__mainContainer--qVKM7";
var _d = "SideColumnLayout-module__mainTitle--VL2ey";
var _e = "SideColumnLayout-module__mainTitleContainer--R7r7q";
var _f = "SideColumnLayout-module__seamless--GJ08b";
var _10 = "SideColumnLayout-module__sideColumnContainer--o7Tb0";
var _11 = "SideColumnLayout-module__sideColumnTitleContainer--m3gjT";
var _12 = "SideColumnLayout-module__tabs--ZG94G";
var _13 = "SideColumnLayout-module__tabsWithControls--QaA8x";
export { _1 as "aboveAllContainer", _2 as "aboveColumnContainer", _3 as "active", _4 as "activeViewContainer", _5 as "animateUploadProgressBarWidth", _6 as "animatedBackground", _7 as "compactLayoutContainer", _8 as "controls", _9 as "controlsToggle", _a as "iconContainer", _b as "layoutContainer", _c as "mainContainer", _d as "mainTitle", _e as "mainTitleContainer", _f as "seamless", _10 as "sideColumnContainer", _11 as "sideColumnTitleContainer", _12 as "tabs", _13 as "tabsWithControls" }
